import { Component } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { SearchComponent } from '../../components/search/search.component';
import { AppModule } from '../../utilities/app/app.module';
import { Router } from '@angular/router';
import { SearchService } from '../../components/search/search-service';

type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string
};


interface LazyEvent {
  first: number;
  last: number;
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [SearchComponent, AppModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

  profile: ProfileType | undefined;
  loggedin_profile: any;
  show_video: boolean = false;
  current_playing_url: string = '';
  search_button_clicked = false;
  activeIndex: number | undefined = 0;

  // this is for lazy loading the videos in the home page
  lazyLoading: boolean = true;
  loadLazyTimeout: any;

  constructor(
    public commonservice: CommonService,
    public searchservice: SearchService,
    private router: Router
  ) {
  }

  ngOnInit() {

    try {
      this.commonservice.logged_in_user_details.subscribe((user_profile: any) => {
        this.loggedin_profile = user_profile;
      });
    } catch (err) {}
    this.searchservice.reset();
  }


  show_video_player(item: any) {
    this.show_video = true;
    this.current_playing_url = item;
  }

  get_data(all_video_data: any) {
    let videos_data: { [key: string]: string[] } = {};
    all_video_data?.forEach((url: string) => {
      let name = this.get_name(url);
      if (name != undefined) {
        if (name in videos_data) {
          videos_data[name].push(url);
        } else {
          videos_data[name] = [url];
        }
      }
    });
    this.items = videos_data
    return videos_data;
  }

  get_name(url: any) {
    try {
      let filename = new URL(url).pathname.split('/').pop();
      return filename;
    } catch (e) {
      console.error(e);
    }
    return '';
  }

  get_outlined(index: number) {
    return this.activeIndex !== index;
  }

  set_active_index(index: number) {
    this.activeIndexChange(index);
  }

  activeIndexChange(index: any) {
    this.activeIndex = index
  }

  clicked_search(event: any) {
    this.search_button_clicked = event;
    this.router.navigate(['/explore'])
  }

  items: any = [{}]; // Your actual data
  chunkSize = 4; // Number of items to display per chunk
  currentPage = 1;

  loadMore(header_name: string) {
    const startIndex = this.currentPage * this.chunkSize;
    const endIndex = startIndex + this.chunkSize;
    this.items = this.items.concat(this.items[header_name].slice(startIndex, endIndex));
    this.currentPage++;
  }
}

